import { Component, output } from '@angular/core';

@Component({
  selector: 'era-device-scheduled-tasks-cancel-ui',
  templateUrl: './device-scheduled-tasks-cancel.component.html',
})
export class DeviceScheduledTasksCancelComponent {
  public readonly cancelled = output();

  public onCancel() {
    this.cancelled.emit();
  }
}
